import React, { useEffect, useState } from "react";

const Xfactor = ({ score, placement }) => {
  //   const score = getRandomNumber(50, 100).toString();

  const numericScore = Number(score);

  const color = (score) => {
    if (score <= 65) return "#EF426F";
    if (score >= 66 && score <= 76) return "#F2853C";
    if (score >= 77 && score <= 86) return "#F7DC62";
    if (score >= 87 && score <= 94) return "#54CE3C";
    if (score >= 95) return "#368911";
    return "#fff";
  };

  const first = score.charAt(0);
  const second = score.substring(1);
  const overall_label = () => {
    return <span className="ovr-label">OVR</span>;
  };

  return (
    <div className={placement === "profile" ? "x-factor-profile" : "x-factor"}>
      {score === "100" ? (
        <div
          style={{ color: color(numericScore) }}
          className={placement === "profile" ? "x-100-profile" : "x-100"}
        >
          {score}
          {placement === "profile" ? overall_label() : null}
        </div>
      ) : (
        <>
          <div
            style={{ color: color(numericScore) }}
            className={placement === "profile" ? "x-1st-profile" : "x-1st"}
          >
            {first}
          </div>
          <div
            style={{ color: color(numericScore) }}
            className={placement === "profile" ? "x-2nd-profile" : "x-2nd"}
          >
            {second}
            {placement === "profile" ? overall_label() : null}
          </div>
        </>
      )}
    </div>
  );
};

export default Xfactor;
